import { __makeTemplateObject } from "tslib";
import React, { Fragment } from 'react';
import styled from 'styled-components';
import { Button, CloseButton, Flex, Heading, PinTR, Text } from '@marvelapp/ui';
import { zendesk } from '@marvelapp/help';
import handoffEmpty from '../images/handoffEmpty.png';
import handoffEmptyRetina from '../images/handoffEmpty@2x.png';
export default function SidebarState(_a) {
    var children = _a.children, heading = _a.heading, image = _a.image, message = _a.message, onClose = _a.onClose;
    return (React.createElement(Fragment, null,
        React.createElement(Flex, { alignItems: "center", flexDirection: "column", height: "100%", justifyContent: "center", px: 40 },
            React.createElement(SidebarImage, { image: image }),
            React.createElement(Heading, { marginBottom: 2, textAlign: "center" }, heading),
            React.createElement(Text, { marginBottom: 3, textAlign: "center" }, message),
            children),
        React.createElement(PinTR, { padding: 20 },
            React.createElement(CloseButton, { height: 30, onClick: onClose, width: 30 }))));
}
export function ContactButton() {
    return (React.createElement(Button, { as: "a", href: zendesk.NEW_TICKET, kind: "ghost", rel: "noopener noreferrer", target: "_blank" }, "Contact support"));
}
export function FindOutMoreButtton() {
    return (React.createElement(Button, { as: "a", href: zendesk.GETTING_STARTED_HANDOFF, kind: "marvel", rel: "noopener noreferrer", target: "_blank" }, "How to use Handoff"));
}
export function SignInButton() {
    return (React.createElement(Button, { as: "a", href: zendesk.GETTING_STARTED_HANDOFF, kind: "marvel", rel: "noopener noreferrer", target: "_blank" }, "Sign In"));
}
export function FindHowToDownloadAssetsButton() {
    return (React.createElement(Button, { as: "a", href: zendesk.GETTING_STARTED_HANDOFF, kind: "ghost", rel: "noopener noreferrer", target: "_blank" }, "Find out how"));
}
function SidebarImage(_a) {
    var image = _a.image;
    if (image === 'handoff') {
        return (React.createElement(Image, { src: handoffEmpty, srcSet: handoffEmpty + " 1x, " + handoffEmptyRetina + " 2x" }));
    }
    return null;
}
var Image = styled.img(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  margin-bottom: 20px;\n  max-width: 320px;\n  width: 90%;\n"], ["\n  display: block;\n  margin-bottom: 20px;\n  max-width: 320px;\n  width: 90%;\n"])));
var templateObject_1;
